var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.94687 3.87349L3.2332 5.91333H11.2668L10.5531 3.87349C10.4301 3.52349 10.0992 3.28833 9.72734 3.28833H4.77266C4.40078 3.28833 4.06992 3.52349 3.94687 3.87349ZM1.33281 6.04458L2.29531 3.29653C2.66445 2.2438 3.65703 1.53833 4.77266 1.53833H9.72734C10.843 1.53833 11.8355 2.2438 12.2047 3.29653L13.1672 6.04458C13.8016 6.30708 14.25 6.93325 14.25 7.66333V11.6008V12.9133C14.25 13.3973 13.859 13.7883 13.375 13.7883H12.5C12.016 13.7883 11.625 13.3973 11.625 12.9133V11.6008H2.875V12.9133C2.875 13.3973 2.48398 13.7883 2 13.7883H1.125C0.641016 13.7883 0.25 13.3973 0.25 12.9133V11.6008V7.66333C0.25 6.93325 0.698437 6.30708 1.33281 6.04458ZM3.75 8.53833C3.75 8.30627 3.65781 8.08371 3.49372 7.91961C3.32962 7.75552 3.10706 7.66333 2.875 7.66333C2.64294 7.66333 2.42038 7.75552 2.25628 7.91961C2.09219 8.08371 2 8.30627 2 8.53833C2 8.77039 2.09219 8.99295 2.25628 9.15705C2.42038 9.32114 2.64294 9.41333 2.875 9.41333C3.10706 9.41333 3.32962 9.32114 3.49372 9.15705C3.65781 8.99295 3.75 8.77039 3.75 8.53833ZM11.625 9.41333C11.8571 9.41333 12.0796 9.32114 12.2437 9.15705C12.4078 8.99295 12.5 8.77039 12.5 8.53833C12.5 8.30627 12.4078 8.08371 12.2437 7.91961C12.0796 7.75552 11.8571 7.66333 11.625 7.66333C11.3929 7.66333 11.1704 7.75552 11.0063 7.91961C10.8422 8.08371 10.75 8.30627 10.75 8.53833C10.75 8.77039 10.8422 8.99295 11.0063 9.15705C11.1704 9.32114 11.3929 9.41333 11.625 9.41333Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.25 0.66333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSolid);
export default __webpack_public_path__ + "static/media/car-solid.8d05817f92e5ddd231dc182d9d38b7dc.svg";
export { ForwardRef as ReactComponent };